import React, { useRef, useState } from 'react'
import FixedView from '../FixedView'


class ActionButton extends React.Component {

    state = {
        isOpen: false
    }
    openActions = () => {
        // console.log("openActions")
        if (this.state.isOpen) {
            // this.setState({ isOpen: false },()=>{
            // setTimeout(() => {
            //     this.fixedView.hideView()
            // }, 5000);
            // })

        } else {
            this.fixedView.showView()
            this.setState({ isOpen: true })
            if (this.props.onOpen) {
                this.props.onOpen()
            }
        }
    }

    onHide = () => {
        // setTimeout(() => {
        this.setState({ isOpen: false })
        // }, 1000);
        if (this.props.onClose) {
            this.props.onClose()
        }

    }

    hide = () => {
        this.fixedView.hideView()
    }



    render() {

        let children = []

        if (this.props.children) {
            if (Array.isArray(this.props.children)) {
                children = this.props.children.map(function (child, i) {

                    if (((typeof this.state.stage == 'string') && (child.props.stageName === this.state.stage)) || ((typeof this.state.stage == 'number') && (child.props.stage === this.state.stage)) || child.props.stage === null) {
                        return React.cloneElement(child,
                            { key: i, hide: this.hide }
                        )
                    }
                    return
                }, this);
            } else {
                children = React.cloneElement(this.props.children,
                    { hide: this.hide }
                )

            }

        }
        return (

            <div className='' >
                <div ref={el => this.currentNode = el} className={'flexcc stage-action-button cursor-pointer ' + (this.state.isOpen ? ' isOpen ' : '')} onClick={(e) => { e.stopPropagation(); this.openActions() }}  >
                    <img className='stage-action-button-img' src={'/assets/icons/useful/action.png'} height={10} width={10} style={{ height: '10px', width: '10px' }} />
                </div>

                {/* {this.props.children} */}

                <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={() => this.onHide()} topOffset={-10} xOffset={-32} zIndex={15} >
                    {children}
                    {/* <p>tets</p> */}
                </FixedView>
            </div>


        )
    }

}

export default ActionButton
